// import Vue from 'vue'
import Vue from 'vue/dist/vue.esm.js'//我们自己找到的带解析的版本
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		firstSelect: "",
		secondSelect: "",
		secondList: [],
		showTopImage: true,
		topImage: '',
		chenLieType: 'jbcl',
		titleList: [],
		enTitleList: [],
		youngTitleList: [],
		youngSelect: "",
		pageList: [],
		lang: 'zh',
		showTop: false,
		secondSelect:0
	},
	mutations: {
		//
	},
	actions: {
		//
	},
	modules: {
		//
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js